import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes ,Route } from 'react-router-dom';

import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import LoginCallback from './pages/LoginCallback';

function App() {
  return (
    <div className="App">
      <CssBaseline />
      <Layout>
        <Router basename={process.env.REACT_APP_BASE_PATH} >
          <Routes>
            <Route path='/' element={<Dashboard/>} />
            <Route path='/c' element={<LoginCallback/>} />
          </Routes>
        </Router>
      </Layout>
    </div>
  );
}

export default App;
